import { XMenu } from './xmenu';

const install = function (app) {
    app.component(XMenu.name, XMenu);
};

export {
    XMenu,
    install,
};
